var React = require('react');
var gameStripUtils = require('../../../helpers/utils/gameStripUtils.js');
var eventTypeStyle = {paddingRight:'5px'};
//console.info('gameStripUtils', gameStripUtils);

/**
 * Get scorers for a particular game
 */
var Scorers = React.createClass({

    render: function(){
        var goals = this.props.goals || [];
        // Return if game has no goals
        if (goals.length === 0) {
            return null;
        }

        //console.info('goals', goals);
        var scorerNodes = goals.map(function(goal,i){
            //console.info('goal', goal);
            var details = gameStripUtils.getPlayerNameLink(goal);
            var clock = gameStripUtils.getFormattedClock(goal);
            //console.info('details', details);
            //console.info('clock', clock);
            return (
                <li key={clock+'-'+i}><a href={details.link}>{details.name}</a><span>({clock})</span></li>
            );
        });

        return (
            <ul className={this.props.sport == 'rugby' ? "goal icon-font-before icon-rugby-solid-before icon-rugby-solid" : 'goal icon-font-before icon-soccer-ball-before icon-soccerball'}>
                {scorerNodes}
            </ul>
        );
    }
});

/**
 * Get red/yellow card information for a particular game
 */
var DisciplineCards = React.createClass({

    render: function(){
        var cards = this.props.cards || [];
        // Return if game has no cards
        if (cards.length === 0) {
            return null;
        }

        // Get card type and create the class name string
        var cardtype = this.props.cardtype;
        var cssClasses = ['icon-font-before', 'icon-soccer-card02-solid-before'];
        var cardClass = cardtype === 'yellow' ? 'icon-yellowcard' : 'icon-redcard';
        cssClasses.push(cardClass);
        var classString = cssClasses.join(' ');

        // Get card related details
        var cardNodes = cards.map(function(card, i){
            var details = gameStripUtils.getPlayerNameLink(card);
            var clock = gameStripUtils.getFormattedClock(card);
            return (
                <li key={clock+'-'+i}><a href={details.link}>{details.name}</a><span>({clock})</span></li>
            );
        });

        return (
            <ul className={classString}>
                {cardNodes}
            </ul>
        );
    }
});

/**
 * Render goalscorers and cards related information for a team
 */
var TeamSummary = React.createClass({

    render: function(){
        var team = this.props.team;

        var goals = team.goals;
        var cards = team.discipline;
        //console.info('TeamSummary: goals', this.props.how, goals);
        //console.info('TeamSummary: cards', this.props.how, cards);

        /**
         * Create separate containers for red and yellow cards
         */
        var yellowCards = [];
        var redCards = [];
        for (var i = 0; i < cards && cards.length; i++) {
            var card = cards[i];
            if (card.redCard === true) {
                redCards.push(card);
            }
            if (card.yellowCard === true) {
                yellowCards.push(card);
            }
        }

        //console.info('TeamSummary: yellow cards', yellowCards);
        //console.info('TeamSummary: red cards', redCards);

        return (
            <div className="team-info players">

                <Scorers goals={goals} sports={this.props.sport}/>
                <DisciplineCards cards={redCards} cardtype="red"/>
                <DisciplineCards cards={yellowCards} cardtype="yellow"/>

            </div>
        );
    }
});


var TryDetails = React.createClass({
    render: function() {
        var tries = this.props.tries;
        var tryNodes = [];
        // Return if game has no cards
        if (tries.length === 0) {
            return null;
        }

        var classString = 'trylist';

        tries.map(function(tri, i){
            //console.info('tri', tri);
            var details = gameStripUtils.getPlayerNameLink(tri);
            var clock = gameStripUtils.getFormattedClock(tri);
            //console.info('details', details);
            //console.info('clock', clock);
            tryNodes.push(<li key={clock+'-'+i}><a href={details.link}>{details.name}</a><span>({clock})</span></li>, ' ');
        });

        return (
            <ul className={classString}>
                <li><b style={eventTypeStyle}>Tries</b></li>
                {tryNodes}
            </ul>
        );
    }
});


var ConvDetails = React.createClass({
    render: function() {
        var cons = this.props.cons;
        var convNodes = [];
        // Return if game has no cards
        if (cons.length === 0) {
            return null;
        }

        var classString = 'goal icon-font-before icon-rugby-conversion-solid-before icon-rugby-conversion-solid';

        cons.map(function(conv, i){
            //console.info('conv', conv);
            var details = gameStripUtils.getPlayerNameLink(conv);
            var clock = gameStripUtils.getFormattedClock(conv);
            //console.info('details', details);
            //console.info('clock', clock);
            convNodes.push(<li key={clock+'-'+i}><a href={details.link}>{details.name}</a><span>({clock})</span></li>, ' ');
        });

        return (
            <ul className={classString}>
                {convNodes}
            </ul>
        );
    }
});


var PenDetails = React.createClass({
    render: function() {
        var pens = this.props.pens;
        var penNodes = [];
        // Return if game has no cards
        if (pens.length === 0) {
            return null;
        }

        var classString = 'goal icon-font-before icon-rugby-penalty-solid-before icon-rugby-penalty-solid';

        pens.map(function(pen, i){
            //console.info('pen', pen);
            var details = gameStripUtils.getPlayerNameLink(pen);
            var clock = gameStripUtils.getFormattedClock(pen);
            //console.info('details', details);
            //console.info('clock', clock);
            penNodes.push(<li key={clock+'-'+i}><a href={details.link}>{details.name}</a><span>({clock})</span></li>, ' ');
        });

        return (
            <ul className={classString}>
                {penNodes}
            </ul>
        );
    }
});


var RedDetails = React.createClass({
    render: function() {
        var reds = this.props.reds;
        // Return if game has no cards
        if (reds.length === 0) {
            return null;
        }

        var classString = 'icon-font-before icon-soccer-card02-solid-before icon-redcard';

        var redNodes = reds.map(function(red, i){
            //console.info('red', red);
            var details = gameStripUtils.getPlayerNameLink(red);
            var clock = gameStripUtils.getFormattedClock(red);
            //console.info('details', details);
            //console.info('clock', clock);
            return (
                <li key={clock+'-'+i}><a href={details.link}>{details.name}</a><span>({clock})</span></li>
            );
        });

        return (
            <ul className={classString}>
                {redNodes}
            </ul>
        );
    }
});

var DropDetails = React.createClass({
    render: function() {
        var drops = this.props.drops;
        var dropNodes = [];
        // Return if game has no cards
        if (drops.length === 0) {
            return null;
        }

        var classString = 'goal icon-font-before icon-rugby-drop-goal-solid-before icon-rugby-drop-goal-solid';

        drops.map(function(drop, i){
            //console.info('drop', drop);
            var details = gameStripUtils.getPlayerNameLink(drop);
            var clock = gameStripUtils.getFormattedClock(drop);
            //console.info('details', details);
            //console.info('clock', clock);
            dropNodes.push(<li key={clock+'-'+i}><a href={details.link}>{details.name}</a><span>({clock})</span></li>, ' ');
        });

        return (
            <ul className={classString}>
                {dropNodes}
            </ul>
        );
    }
});

/**
 * Component to display rugby stats
 */
var RugbyStat = React.createClass({
    render: function(){
        var stats = this.props.stats;
        var statname = this.props.statname;

        // whitelist of stats and related lookup details
        var statsMap = {
            'tries': {
                displayText: 'Tries',
                classString: 'goal icon-font-before icon-rugby-solid-before icon-rugby-solid'
            },
            'cons': {
                displayText: 'Cons',
                classString: 'goal icon-font-before icon-rugby-conversion-solid-before icon-rugby-conversion-solid'
            },
            'pens': {
                displayText: 'Pens',
                classString: 'goal icon-font-before icon-rugby-penalty-solid-before icon-rugby-penalty-solid'
            },
            'reds': {
                displayText: 'Reds',
                classString: 'icon-font-before icon-soccer-card02-solid-before icon-redcard'
            },
            'drops': {
                displayText: 'Drops',
                classString: 'goal icon-font-before icon-rugby-drop-goal-solid-before icon-rugby-drop-goal-solid'
            }
        };

        // Return if this side has no stats available
        if (stats.length === 0 || statsMap.hasOwnProperty(statname) === false) {
            return null;
        }

        // Cache lookup from statsMap
        var config = statsMap[statname];
        var allstats = stats[0];
        //console.info('stats', stats);
        //console.info('statname', statname, 'stats', allstats);

        // Store formatted stats. Each object will corrospond to single player.
        var formattedStats = [];

        // Iterate over each player id in stat. Build data in required format.
        for (var playerId in allstats) {
            //console.info('playerId', playerId);
            var playerStat = allstats[playerId];
            //console.info('playerStat', playerStat);

            // Set defaults data format
            var stat = {
                playerId : playerId,
                displayClock : '',
                playerName : '',
                playerLink : ''
            };

            // Lookup and set times, name and link
            if (playerStat.hasOwnProperty('times')) {
                stat.displayClock = playerStat.times.join(', ');
            }
            if (playerStat.hasOwnProperty('name')){
                stat.playerName = playerStat.name;
            }
            if (playerStat.hasOwnProperty('link')){
                stat.playerLink = playerStat.link;
            }
            if (playerStat.hasOwnProperty('rawClock')){
                stat.rawClock = playerStat.rawClock;
            }
            //console.info(stat);

            // Append to stats
            formattedStats.push(stat);
        }
        //console.info('formattedStats', formattedStats);

        // Sort the events on rawclock ascending value
        formattedStats.sort(function(a, b) {
            try {
                return a.rawClock - b.rawClock;
            } catch (e) {
                return 0;
            }
        });

        // Loop over formattedStats and build html nodes
        var statNodesMarkup = '';

        formattedStats.map(function(stat, i){
            // Return only if valid player id is found.
            if ('playerId' in stat){
                statNodesMarkup += '<li><a target="_blank" href="' + stat.playerLink + '">' + stat.playerName + '</a><span>(' + stat.displayClock + ')</span></li> ';
                
            }
        });

        // Return stats in a ul.
        return (
            <ul className={config.classString} dangerouslySetInnerHTML={{__html : statNodesMarkup}}></ul>
        );
    }
});


/**
 * Render rugby details for a team
 */
var RugbySummary = React.createClass({
    render: function(){
        var team = this.props.team;

        var tries = team.tries;
        var cons = team.cons;
        var pens = team.pens;
        var reds = team.reds;
        var drops = team.drops;

        return (
            <div className="team-info players">
                <RugbyStat stats={tries} statname='tries' />
                <RugbyStat stats={cons} statname='cons' />
                <RugbyStat stats={pens} statname='pens' />
                <RugbyStat stats={reds} statname='reds' />
                <RugbyStat stats={drops} statname='drops' />
            </div>
        );
    }
});

/**
 * Render game summary for home and away teams
 */
var GameSummary = React.createClass({
    render: function(){
        var summary = this.props.summary;
        var homeSummary = summary.home;
        var awaySummary = summary.away;
        var homeSummaryComponent = null;
        var awaySummaryComponent = null;

        if(this.props.sport === 'rugby'){
            homeSummaryComponent = <RugbySummary team={homeSummary} how='home'/>;
            awaySummaryComponent = <RugbySummary team={awaySummary} how='away'/>;
        }else{
            homeSummaryComponent = <TeamSummary team={homeSummary} how='home'/>;
            awaySummaryComponent = <TeamSummary team={awaySummary} how='away'/>;
        }
        //console.info('\nGameSummary:', summary);

        /**
         * Swap home, away teams since for domestic, home team appears on right
         * For football, home team should be on left.
         */

        return (
            <div className="competitors">
                <div className="team away">
                    {homeSummaryComponent}
                </div>
                <div className="team home">
                    {awaySummaryComponent}
                </div>
            </div>
        );
    }
});

module.exports = GameSummary;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/scoreboard/game-strip/GameSummary.jsx
 **/